var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1822_46939)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1822_46939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.84684H9.16667V3.18018H2.5V9.84684ZM4.16667 4.84684H7.5V8.18018H4.16667V4.84684Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.834 3.18018V9.84684H17.5007V3.18018H10.834ZM15.834 8.18018H12.5007V4.84684H15.834V8.18018Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.1799H9.16667V11.5132H2.5V18.1799ZM4.16667 13.1799H7.5V16.5132H4.16667V13.1799Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 11.5132H13.334V14.0132H10.834V15.6799H13.334V18.1799H15.0007V15.6799H17.5007V14.0132H15.0007V11.5132Z",
    fill: "#A6A6A6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1822_46939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.680176)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1822_46939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.680176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c148f0a0ed802ffbc80b9de752f2134c.svg";
export { ForwardRef as ReactComponent };